import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
  countryId: yup.string(),
  nonReeferTransportCostPerPallet: yup.number().label('Non-Reefer Transport Cost'),
  reeferTransportCostPerPallet: yup.number().label('Reefer Transport Cost'),
  uniqueCompanyNumber: yup.string().label('Unique Company Number').min(2, 'Unique Company Number should be at least 2 symbols').required('Unique Company Number is required')
});

export default schema;
